<script setup lang="ts">
//
</script>

<template>
  <div class="aspect-square rounded-lg bg-white" />
</template>
